import React from 'react';
import Container from 'react-bootstrap/Container';

import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';

function PostCallToAction() {
  return (
    <div className="site-section" id="dark-gray-background">
      <Container className="centered">
        <br />
        <h1 className="heading-light">Hope you enjoyed this post!</h1>
        <br />
        <h3 className="light">Maybe you'll enjoy the other ones even more</h3>
        <br />
        <a href="/whatsnew" className="hero-button" id="`dark-yellow">
          What's New
        </a>
      </Container>

    </div>
  );
}

export default PostCallToAction;
